import React, { useEffect } from 'react';
import { Col, Row } from 'antd';
import { SettingsRouteProps } from './Settings';
import { useSelector } from 'react-redux';
import i18next from 'i18next';
import { getSettingsState } from '../../store/settings/selector';

export const Terms: React.FC<SettingsRouteProps> = ({ setHeaderTitle }) => {
  const { settings } = useSelector(getSettingsState);
  const setHeader: React.EffectCallback = () => {
    if (setHeaderTitle) setHeaderTitle('Terms and Conditions');
  };
  useEffect(setHeader, [setHeaderTitle]);
  // console.log(i18next.language);
  return (
    <Row justify="start" className="account-details-block margin-top">
      {/* <Col className="title">Headline</Col> */}
      <Col className="description">
        <div
          dangerouslySetInnerHTML={{
            __html:
              i18next.language === 'en'
                ? settings.terms
                : i18next.language === 'cz'
                ? settings.termscz
                : settings.termsit,
          }}
          className="with-padding-bottom"
        />
      </Col>
    </Row>
  );
};
